import { render, staticRenderFns } from "./RoomUser.vue?vue&type=template&id=8067ce9a&scoped=true&"
import script from "./RoomUser.vue?vue&type=script&lang=js&"
export * from "./RoomUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8067ce9a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8067ce9a')) {
      api.createRecord('8067ce9a', component.options)
    } else {
      api.reload('8067ce9a', component.options)
    }
    module.hot.accept("./RoomUser.vue?vue&type=template&id=8067ce9a&scoped=true&", function () {
      api.rerender('8067ce9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Sysadmin/RoomUser.vue"
export default component.exports